/* eslint-disable @typescript-eslint/no-magic-numbers */
import { useTranslation } from 'react-i18next';

import { string } from '@/utils/validation';

export const useCenterValidationSchema = () => {
  const { t } = useTranslation('apiError');

  return {
    adminCode: string()
      .minLength(4, t('adminCodeMinLengthValidation'))
      .maxLength(128, t('adminCodeMaxLengthValidation'))
      .alphaNumericWithUnderscores(t('adminCodeWithUnderscores'))
      .required(t('adminCodeRequired')),
    programCode: string()
      .minLength(4, t('programCodeMinLengthValidation'))
      .maxLength(128, t('programCodeMaxLengthValidation'))
      .alphaNumericWithSymbols(t('programCodeWithSymbols'))
      .required(t('programCodeRequired')),
    password: string()
      // .addTest(
      //   (value: unknown) => /^(?=.*\d).{6,}$/.test(value as string),
      //   t('passwordRequirement'),
      // )
      .minLength(6, t('passwordMinLengthValidation'))
      .maxLength(128, t('passwordMaxLengthValidation'))
      .required(t('passwordRequired')),
  };
};

export default useCenterValidationSchema;
